import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import { Button } from '../../../../../../../../components/common/Buttons';
import ChipGroup from '../../../../../../../../components/common/Chip/ChipGroup';
import SpacingContainer from '../../../../../../../../components/common/Containers/Base/SpacingContainer';
import Typography from '../../../../../../../../components/common/Typography';
import { ChipOption } from '../../../../../../../../components/generics/SearchTopPanel/SelectedFilterslist/ChipOption';
import { useTrans } from '../../../../../../../../services/i18n';
import { emptyArray } from '../../../../../../../../utils/arrayUtils';
import connect from '../../../../../connect';
import { buildActiveFilterChips, createUpdatedListFilters, removeFilterListValue } from './helpers';

export function ActiveFiltersSummary({ filters, changeFilters, getList }) {
  const { trans } = useTrans();
  const { filters: activeFilterMap, type: filterType } = filters;

  const applyNext = (updater) => {
    const next = createUpdatedListFilters(filters, updater);
    changeFilters(next);
    getList(next);
  };

  const removeListValue = (key, index) => {
    applyNext((next) => {
      next.filters = removeFilterListValue(next.filters, key, index);
    });
  };

  const removeExpiration = () => {
    applyNext((next) => {
      next.type = 'all';
    });
  };

  const resetAll = () => {
    applyNext((next) => {
      next.type = 'all';
      next.filters = {};
    });
  };

  const chips = buildActiveFilterChips({
    filterType,
    activeFilterMap,
    labels: {
      expirationStatus: trans('expiration-status'),
      setAsides: trans('set-asides'),
      naics: trans('naics-code'),
      locations: trans('locations'),
      tag: trans('tag'),
    },
    handlers: {
      removeExpiration,
      removeListValue,
    },
  });

  if (emptyArray(chips)) return null;

  return (
    <SpacingContainer px={3} py={1} style={{ background: 'white', borderTop: '1px solid #e9ebee' }}>
      <Grid container alignItems="center" spacing={1}>
        {chips.map((chip) => (
          <Grid item component={ChipGroup} key={chip.key}>
            <ChipOption name={chip.name} value={chip.value} onDelete={chip.onDelete} />
          </Grid>
        ))}
        <Grid item>
          <Button color="primary" variant="text" size="small" onClick={resetAll}>
            <Typography variant="caption" weight="600" color="primary">
              {trans('reset')}
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </SpacingContainer>
  );
}

const filterFieldShape = PropTypes.shape({
  type: PropTypes.string,
  value: PropTypes.array,
});

ActiveFiltersSummary.propTypes = {
  filters: PropTypes.shape({
    type: PropTypes.string,
    pagination: PropTypes.shape({
      page: PropTypes.number,
      perPage: PropTypes.number,
    }).isRequired,
    filters: PropTypes.shape({
      tags: filterFieldShape,
      naics: filterFieldShape,
      setAsides: filterFieldShape,
      state: filterFieldShape,
    }).isRequired,
  }).isRequired,
  changeFilters: PropTypes.func.isRequired,
  getList: PropTypes.func.isRequired,
};

export default connect(ActiveFiltersSummary);
